<template>
    <div class="task_page-new" id="task_answer">
        <div class="task_main" ref="middle_page">
            <div class="taskPage">
                <!-- Tên khóa học -->
                <div class="primarylists list-mobile">
                    <div class="titles clear">
                        <img src="../../../static/images/icon-st.jpg"/>
                        <span class="title l">{{ $t("previewBook.previewBook") }}</span>
                        <p><span class="title l"></span></p>
                    </div>
                </div>

                <!-- Control --> 
                <div class="div-btn-icon">
                    <!-- Quay lại -->
                    <button class="btn-tast btn-next-1" @click="back()">
                        <img src="../../../static/images/icon-back-1.png" />
                        <span>{{$t('common.returnButton')}}</span>
                    </button>

                    <!-- Câu trước -->
                    <template>
                        <template v-if="activeItem == 0">
                            <button style="cursor: no-drop;" class="btn-tast">
                                <img src="../../../static/images/back-den.png" />
                                <span style="color: black;">{{$t('task_result.prev')}}</span>
                            </button>
                        </template>
                        <template v-else>
                            <button class="btn-tast" @click="toogleQuestion(activeItem - 1)">
                                <img src="../../../static/images/icon-back.png" />
                                <span>{{$t('task_result.prev')}}</span>
                            </button>
                        </template>
                    </template>

                    <!-- Câu sau -->
                    <template>
                        <template v-if="this.questions.length == (activeItem + 1)">
                            <button style="cursor: no-drop;" class="btn-tast xoay">
                                <img src="../../../static/images/back-den.png" />
                                <span style="color: black;">{{$t('task_result.next')}}</span>
                            </button>
                        </template>
                        <template v-else>
                            <button class="btn-tast xoay" @click="toogleQuestion(activeItem + 1)">
                                <img src="../../../static/images/icon-back.png" />
                                <span>{{$t('task_result.next')}}</span>
                            </button>
                        </template>
                    </template>

                </div>

                <!-- Nội dung -->
                <div class="taskPage_task taskPage_task_edit" v-if="currentQuestionInfo != null">
                    <div class="taskContent_main">
                        <div class="task-flex">
                            <div class="task_content">
                                <!-- Nội dung câu hỏi -->
                                <div class="fix-img-h line-height" v-html="currentQuestionInfo.questionContent"></div>

                                <!-- Câu hỏi âm thanh -->
                                <audio v-if="checkedAudio(currentQuestionInfo.audioName)" controls="controls" :src="currentQuestionInfo.audioPath" controlsList="nodownload" oncontextmenu=" return false" class="audio"></audio>

                                <!-- Câu hỏi video -->
                                <video v-if="checkedVideo(currentQuestionInfo.audioName)" :src="currentQuestionInfo.audioPath" controls="controls" controlsList="nodownload" class="video"></video>
                            </div>

                            <!-- Đáp án của câu hỏi -->
                            <div class="tast-right">
                                <!-- Loại câu hỏi của bài đọc hiểu -->
                                <template v-for="(item, index) in currentQuestionInfo.subQuestionList">
                                  <div class="nhts223" :class="{flxs: item.questionContent == null}" :key="index" v-if="parseInt(currentQuestionInfo.questionTypeId) == 4">

                                    <p class="nhts223-pp-p line-height" v-if="item.questionContent == null">{{index + 1}}.&nbsp;</p>
                                    <span class="line-height" v-html="item.questionContent" v-if="item.questionContent != null"></span>

                                    <div class="task_answer_radio nhts-he">
                                        <span v-if="item.optionA" class="ml-dh-auto" :class="{mb: mobile}">
                                            <input v-model="obsever[activeItem].subQuestionList[index].questionAnswer" :id="'radio_s_a_' + index" type="radio" value="A" disabled="disabled"/>
                                            <label :for="'radio_s_a_' + index">
                                                <span class="nmjs line-height" v-html="item.optionA"></span>
                                            </label>
                                        </span>
                                        <span v-if="item.optionB" class="ml-dh-auto" :class="{mb: mobile}">
                                            <input v-model="obsever[activeItem].subQuestionList[index].questionAnswer" :id="'radio_s_b_' + index" type="radio" value="B" disabled="disabled"/>
                                            <label :for="'radio_s_b_' + index">
                                                <span class="nmjs line-height" v-html="item.optionB"></span>
                                            </label>
                                        </span>
                                        <span v-if="item.optionC" class="ml-dh-auto ms34" :class="{mb: mobile}">
                                            <input v-model="obsever[activeItem].subQuestionList[index].questionAnswer" :id="'radio_s_c_' + index" type="radio" value="C" disabled="disabled"/>
                                            <label :for="'radio_s_c_' + index">
                                                <span class="nmjs line-height" v-html="item.optionC"></span>
                                            </label>
                                        </span>
                                        <span v-if="item.optionD" class="ml-dh-auto ms34" :class="{mb: mobile}">
                                            <input v-model="obsever[activeItem].subQuestionList[index].questionAnswer" :id="'radio_s_d_' + index" type="radio" value="D" disabled="disabled"/>
                                            <label :for="'radio_s_d_' + index">
                                                <span class="nmjs line-height" v-html="item.optionD"></span>
                                            </label>
                                        </span>
                                    </div>
                                  </div>
                                </template>

                                <!-- Loại radio -->
                                <div class="task_answer_radio" v-if="parseInt(currentQuestionInfo.questionTypeId) == 1">
                                    <p v-if="currentQuestionInfo.optionA">
                                        <input v-model="radioAnswer" id="radio_a" type="radio" name="radio" value="A" disabled="disabled"/>
                                        <label for="radio_a">
                                            <span class="nmjs line-height" v-html="currentQuestionInfo.optionA"></span>
                                        </label>
                                    </p>
                                    <p v-if="currentQuestionInfo.optionB">
                                        <input v-model="radioAnswer" id="radio_b" type="radio" name="radio" value="B" disabled="disabled"/>
                                        <label for="radio_b">
                                            <span class="nmjs line-height" v-html="currentQuestionInfo.optionB"></span>
                                        </label>
                                    </p>
                                    <p v-if="currentQuestionInfo.optionC">
                                        <input v-model="radioAnswer" id="radio_c" type="radio" name="radio" value="C" disabled="disabled" />
                                        <label for="radio_c">
                                            <span class="nmjs line-height" v-html="currentQuestionInfo.optionC"></span>
                                        </label>
                                    </p>
                                    <p v-if="currentQuestionInfo.optionD">
                                        <input v-model="radioAnswer" id="radio_d" type="radio" name="radio" value="D" disabled="disabled"/>
                                        <label for="radio_d">
                                            <span class="nmjs line-height" v-html="currentQuestionInfo.optionD"></span>
                                        </label>
                                    </p>
                                    <p v-if="currentQuestionInfo.optionE">
                                        <input v-model="radioAnswer" id="radio_e" type="radio" name="radio" value="E" disabled="disabled"/>
                                        <label for="radio_e">
                                            <span class="nmjs line-height" v-html="currentQuestionInfo.optionE"></span>
                                        </label>
                                    </p>
                                    <p v-if="currentQuestionInfo.optionF">
                                        <input v-model="radioAnswer" id="radio_f" type="radio" name="radio" value="F" disabled="disabled"/>
                                        <label for="radio_f">
                                            <span class="nmjs line-height" v-html="currentQuestionInfo.optionF"></span>
                                        </label>
                                    </p>
                                    <p v-if="currentQuestionInfo.optionG">
                                        <input v-model="radioAnswer" id="radio_g" type="radio" name="radio" value="G" disabled="disabled"/>
                                        <label for="radio_g">
                                            <span class="nmjs line-height" v-html="currentQuestionInfo.optionG"></span>
                                        </label>
                                    </p>
                                    <p v-if="currentQuestionInfo.optionH">
                                        <input v-model="radioAnswer" id="radio_h" type="radio" name="radio" value="H" disabled="disabled"/>
                                        <label for="radio_h">
                                            <span class="nmjs line-height" v-html="currentQuestionInfo.optionH"></span>
                                        </label>
                                    </p>
                                    <p v-if="currentQuestionInfo.optionI">
                                        <input v-model="radioAnswer" id="radio_i" type="radio" name="radio" value="I" disabled="disabled"/>
                                        <label for="radio_i">
                                            <span class="nmjs" v-html="currentQuestionInfo.optionI"></span>
                                        </label>
                                    </p>
                                    <p v-if="currentQuestionInfo.optionJ">
                                        <input v-model="radioAnswer" id="radio_j" type="radio" name="radio" value="J" disabled="disabled"/>
                                        <label for="radio_j">
                                            <span class="nmjs line-height" v-html="currentQuestionInfo.optionJ"></span>
                                        </label>
                                    </p>
                                </div>

                                <!-- Loại checkBox -->
                                <div class="task_answer_radio task_answer_checkbox" v-if="parseInt(currentQuestionInfo.questionTypeId) == 2">
                                    <p v-if="currentQuestionInfo.optionA">
                                        <input class="ip-check" v-model="checkBoxAnswer" id="checkbox_a" type="checkbox" value="A" disabled="disabled"/>
                                        <label for="checkbox_a">
                                            <span class="nmjs line-height" v-html="currentQuestionInfo.optionA"></span>
                                        </label>
                                    </p>
                                    <p v-if="currentQuestionInfo.optionB">
                                        <input class="ip-check" v-model="checkBoxAnswer" id="checkbox_b" type="checkbox" value="B" disabled="disabled"/>
                                        <label for="checkbox_b">
                                            <span class="nmjs line-height" v-html="currentQuestionInfo.optionB"></span>
                                        </label>
                                    </p>
                                    <p v-if="currentQuestionInfo.optionC">
                                        <input class="ip-check" v-model="checkBoxAnswer" id="checkbox_c" type="checkbox" value="C" disabled="disabled"/>
                                        <label for="checkbox_c">
                                            <span class="nmjs line-height" v-html="currentQuestionInfo.optionC"></span>
                                        </label>
                                    </p>
                                    <p v-if="currentQuestionInfo.optionD">
                                        <input class="ip-check" v-model="checkBoxAnswer" id="checkbox_d" type="checkbox" value="D" disabled="disabled"/>
                                        <label for="checkbox_d">
                                            <span class="nmjs line-height" v-html="currentQuestionInfo.optionD"></span>
                                        </label>
                                    </p>
                                    <p v-if="currentQuestionInfo.optionE">
                                        <input class="ip-check" v-model="checkBoxAnswer" id="checkbox_e" type="checkbox" value="E" disabled="disabled"/>
                                        <label for="checkbox_e">
                                            <span class="nmjs line-height" v-html="currentQuestionInfo.optionE"></span>
                                        </label>
                                    </p>
                                    <p v-if="currentQuestionInfo.optionF">
                                        <input class="ip-check" v-model="checkBoxAnswer" id="checkbox_f" type="checkbox" value="F" disabled="disabled"/>
                                        <label for="checkbox_f">
                                            <span class="nmjs line-height" v-html="currentQuestionInfo.optionF"></span>
                                        </label>
                                    </p>
                                    <p v-if="currentQuestionInfo.optionG">
                                        <input class="ip-check" v-model="checkBoxAnswer" id="checkbox_g" type="checkbox" value="G" disabled="disabled"/>
                                        <label for="checkbox_g">
                                            <span class="nmjs line-height" v-html="currentQuestionInfo.optionG"></span>
                                        </label>
                                    </p>
                                    <p v-if="currentQuestionInfo.optionH">
                                        <input class="ip-check" v-model="checkBoxAnswer" id="checkbox_h" type="checkbox" value="H" disabled="disabled"/>
                                        <label for="checkbox_h">
                                            <span class="nmjs line-height" v-html="currentQuestionInfo.optionH"></span>
                                        </label>
                                    </p>
                                    <p v-if="currentQuestionInfo.optionI">
                                        <input class="ip-check" v-model="checkBoxAnswer" id="checkbox_i" type="checkbox" value="I" disabled="disabled"/>
                                        <label for="checkbox_i">
                                            <span class="nmjs line-height" v-html="currentQuestionInfo.optionI"></span>
                                        </label>
                                    </p>
                                    <p v-if="currentQuestionInfo.optionJ">
                                        <input class="ip-check" v-model="checkBoxAnswer" id="checkbox_j" type="checkbox" value="J" disabled="disabled"/>
                                        <label for="checkbox_j">
                                            <span class="nmjs line-height" v-html="currentQuestionInfo.optionJ"></span>
                                        </label>
                                    </p>
                                </div>
                            </div>
                            <!-- Loại textarea -->
                            <div style="display:none"  class="tast-right tast-chat" v-if="parseInt(currentQuestionInfo.questionTypeId) == 3 && currentQuestionInfo.subQuestionWrongBook == null">
                                <div class="task_answer_text">
                                    <textarea name="" :placeholder="$t('errorBook.answerInput')" v-model="textAreaAnswer"></textarea>
                                </div>
                            </div>
                        </div>

                        <!-- Phần giải thích -->
                        <div class="task_result">
                            <!-- Đáp án đúng -->
                            <template v-if="parseInt(currentQuestionInfo.questionTypeId) != 4">
                                <div class="task_result_answer">
                                    <p class="task_result_answer_a">{{$t('task_result.answer')}}：</p>
                                    <p class="task_result_answer_b" v-html="currentQuestionInfo.questionAnswer"></p>
                                </div>
                            </template>

                            <!-- Dáp án câu hỏi đoạn văn -->
                            <div class="doan_van" v-if="parseInt(currentQuestionInfo.questionTypeId) == 4">
                                <p class="dap_an">{{$t('task_result.answer')}}:</p>
                                <template v-for="(item, index) in currentQuestionInfo.subQuestionList">
                                    <div class="d-flex" :key="index">
                                      <p class="cau_hoi">{{$t('task_result.question')}} {{index + 1}}:</p>
                                      <p class="cau_tra_loi" v-html="item.questionAnswer"></p>
                                  </div>
                                </template>
                            </div>

                            <br v-if="parseInt(currentQuestionInfo.questionTypeId) != 4"/>

                            <template>
                                <!-- Phân tích -->
                                <div class="task_result_analysis" v-show="currentQuestionInfo.questionAnalysis">
                                    <p class="task_result_analysis_a">{{$t('task_result.analysis')}}：</p>
                                    <p v-html="currentQuestionInfo.errorReason"></p>
                                </div>

                                <!-- Câu trả lời -->
                                <div class="task_result_analysis_answer" v-show="currentQuestionInfo.questionAnalysis">
                                    <p v-html="currentQuestionInfo.questionAnalysis"></p>
                                </div>
                            </template>

                            <!-- Mục đáp án ở trường hợp không hiển thị đáp án -->
                            <template>
                                <div class="task_result_answer" v-if="parseInt(currentQuestionInfo.resolutionFlag) == 0">
                                    <p class="task_result_answer_a">{{$t('task_result.answer')}}：</p>
                                    <p class="task_result_answer_b">{{$t('task_result.unShowAnswer')}}</p>
                                </div>
                            </template>
                        </div>

                        <!-- Phân trang -->
                        <div class="taskContent_page">
                            <ul>
                              <template v-for="(item, index) in questions">
                                <li :key="index" @click="toogleQuestion(index)" :class="[{activeItem: index == activeItem}]">
                                  <p>{{index + 1}}</p>
                                </li>
                              </template>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Loading -->
        <loading :showLoading="loading" />
    </div>
</template>

<script>
    import { mapState } from "vuex";
    import loading from "@/components/loading/loading";

    export default {
        name: "answer",
        components: {
            loading,
        },
        data() {
            return {
                activeItem: null,
                loading: false,
                currentQuestionInfo: {},
                questions: [],
                obsever: [],
                radioAnswer: null,
                checkBoxAnswer: null,
                textAreaAnswer: null,
                data: {}
            };
        },
        created() {
            this.$autoLogin().then(
                () => {
                    this.init();
                },
                () => {
                    this.$router.push({
                        path: "/home",
                    });
                }
            );
        },
        computed: {
            // Lấy dữ liệu từ store
            ...mapState({
                mobile: (state) => state.header.mobile,
            }),
        },
        watch: {
            activeItem: function (newValue, oldValue) {
                // Reset data
                this.radioAnswer = null;
                this.checkBoxAnswer = null;
                this.textAreaAnswer = null;

                // Đổi câu hỏi
                if (this.questions.length) {
                    this.currentQuestionInfo = this.questions[newValue];
                    if (parseInt(this.currentQuestionInfo.questionTypeId) == 1) {
                        this.radioAnswer = this.currentQuestionInfo.questionAnswer;
                    }

                    if (parseInt(this.currentQuestionInfo.questionTypeId) == 2) {
                        this.checkBoxAnswer = this.currentQuestionInfo.questionAnswer == null ? null : this.currentQuestionInfo.questionAnswer.toString().split(",");
                    }

                    if (parseInt(this.currentQuestionInfo.questionTypeId) == 3) {
                        this.textAreaAnswer = this.currentQuestionInfo.questionAnswer;
                    }
                } else {
                    this.currentQuestionInfo = null;
                }
            },

            loading: function (newValue) {
                if (!newValue) {
                    // Reset data
                    this.radioAnswer = null;
                    this.checkBoxAnswer = null;
                    this.textAreaAnswer = null;

                    // Đổi câu hỏi
                    if (this.questions.length) {
                        this.currentQuestionInfo = this.questions[this.activeItem];
                        if (parseInt(this.currentQuestionInfo.questionTypeId) == 1) {
                            this.radioAnswer = this.currentQuestionInfo.questionAnswer;
                        }

                        if (parseInt(this.currentQuestionInfo.questionTypeId) == 2) {
                            this.checkBoxAnswer = this.currentQuestionInfo.questionAnswer == null ? null : this.currentQuestionInfo.questionAnswer.toString().split(",");
                        }

                        if (parseInt(this.currentQuestionInfo.questionTypeId) == 3) {
                            this.textAreaAnswer = this.currentQuestionInfo.questionAnswer;
                        }
                    } else {
                        this.currentQuestionInfo = null;
                    }
                }
            },

            currentQuestionInfo (value) {
                if (value == null) {
                    this.$alert(window.vm.$i18n.t("new.title209"), "", {
                        confirmButtonText: window.vm.$i18n.t("js.confirm"),
                        type:"warning",
                    }).then(() => {
                        this.$router.push({
                            path: "/home/exam/wrongbookBegin",
                            query: {
                                courseId: this.$route.query.courseId,
                                courseName: this.$route.query.courseName,
                                examFlag: this.$route.query.examFlag,
                            },
                        });
                    }).catch(() => {
                        this.$router.push({
                            path: "/home/exam/wrongbookBegin",
                            query: {
                                courseId: this.$route.query.courseId,
                                courseName: this.$route.query.courseName,
                                examFlag: this.$route.query.examFlag,
                            },
                        });
                    });
                }
            }
        },
        methods: {
            // Bắt đầu
            init: async function () {
                // Thông tin khóa học
                this.data.examId = this.$route.query.examId;
                this.data.courseId = this.$route.query.courseId;
                this.data.courseName = this.$route.query.courseName;

                //  Mở loading
                this.loading = true;

                // Lấy danh sách câu hỏi bài tập
                let result = await this.getListFinalCourse({courseId: this.data.courseId, examId: this.data.examId});
                this.questions = result.questions;
                this.obsever = result.questions;

                // Hiển thị câu hỏi đầu tiên
                this.activeItem = 0;

                // Đóng loading
                this.loading = false;
            },

            // Lấy danh sách nội dung câu hỏi cuối kì
            getListFinalCourse: function (data) {
                const self = this;
                return new Promise((resolve, reject) => {
                    this.$api
                        .post("/studyCourseQuestion/getExamQuestionsByCourseIdPreview", {
                            languageType: this.$lang(),
                            courseId: data.courseId,
                            examId: data.examId
                        })
                        .then((response) => {
                            const questions = response.data.questions.reduce((accumulator, value) => {
                                value.questionNum = parseInt(value.questionNum);
                                value.preAnswer = value.questionAnswer == null ? false : true;
                                if (parseInt(value.questionTypeId) == 2) {
                                    value.questionAnswer = value.questionAnswer == null || value.questionAnswer == "" ? [] : value.questionAnswer.split(",");
                                }

                                if (value.errorReason != null && value.errorReason != undefined) {
                                    value.errorReason = value.errorReason.replaceAll("\r\n", "<br>").replaceAll("\n", "<br>");
                                }

                                // Đáp án
                                value.optionA = self.checkTab('A', value.optionA);
                                value.optionB = self.checkTab('B', value.optionB);
                                value.optionC = self.checkTab('C', value.optionC);
                                value.optionD = self.checkTab('D', value.optionD);
                                value.optionE = self.checkTab('E', value.optionE);
                                value.optionF = self.checkTab('F', value.optionF);
                                value.optionG = self.checkTab('G', value.optionG);
                                value.optionH = self.checkTab('H', value.optionH);
                                value.optionI = self.checkTab('I', value.optionI);
                                value.optionJ = self.checkTab('J', value.optionJ);

                                // Nội dung câu hỏi
                                value.questionContent = self.checkTab(null, value.questionContent);

                                if (value.subQuestionWrongBook != null) {
                                    let subQuestionWrongBook = value.subQuestionWrongBook.reduce((a, v) => {
                                        // Đáp án
                                        v.optionA = self.checkTab('A', v.optionA);
                                        v.optionB = self.checkTab('B', v.optionB);
                                        v.optionC = self.checkTab('C', v.optionC);
                                        v.optionD = self.checkTab('D', v.optionD);
                                        v.optionE = self.checkTab('E', v.optionE);
                                        v.optionF = self.checkTab('F', v.optionF);
                                        v.optionG = self.checkTab('G', v.optionG);
                                        v.optionH = self.checkTab('H', v.optionH);
                                        v.optionI = self.checkTab('I', v.optionI);
                                        v.optionJ = self.checkTab('J', v.optionJ);

                                        // Nội dung câu hỏi
                                        v.questionContent = self.checkTab(null, v.questionContent);

                                        a.push(v);
                                        return a;
                                    }, []);
                                    
                                    // Câu hỏi đoạn văn
                                    value.subQuestionWrongBook = subQuestionWrongBook;
                                }

                                accumulator.push(value);
                                return accumulator;
                            }, []);
                            resolve({ questions: questions});
                        })
                        .catch((err) => {
                            reject(err.response);
                        });
                });
            },


            checkTab: function (name, str) {
                let question = "";

                if (name != null && str != null && str != "") {
                    let tag = this.findTagInString(str);
                    question = `<${tag.tagName} style="${tag.style || ""}">${name + ".&nbsp;"}</${tag.tagName}><div class="html__custom">${str.replace(/&nbsp;/g, "")}</div>`;
                }

                if (name == null && str != null && str != "") {
                    question = str.replace(/&nbsp;/g, '');
                }

                return question;
            },

            // Kiểm tra field
            checkedEmpty: function (str) {
                let status = false;

                if (str != undefined && str != null && str != "") {
                    status = true;
                }

                return status;
            },

            // Kiểm tra video
            checkedVideo: function (str) {
                let status = false;

                if (!this.checkedEmpty(str)) {
                    status = false;
                } else {
                    if ("mp4" == str.substring(str.lastIndexOf(".") + 1)) {
                        status = true;
                    }
                }

                return status;
            },

            // Kiểm tra audio
            checkedAudio: function (str) {
                let status = false;

                if (!this.checkedEmpty(str)) {
                    status = false;
                } else {
                    if ("mp3" == str.substring(str.lastIndexOf(".") + 1)) {
                        status = true;
                    }
                }

                return status;
            },

            // Thay đổi câu hỏi
            toogleQuestion: function (index) {
                this.activeItem = index;
            },

            // Quay lại trang mục lục
            back: function () {
                this.$router.push({
                    path: "preview",
                    query: {
                        examId : this.$route.query.examId,
                        courseId : this.$route.query.courseId,
                        courseName : this.$route.query.courseName,
                    },
                });
            },
        },
    };
</script>

<style scoped>
    .list-mobile {
        max-width: 1200px;
        margin: 0 auto;
    }
    .dap_an {
      white-space: nowrap;
      color: rgba(10, 10, 10, 0.5);
    }
    .cau_tra_loi {
      color: #0071c5;
      margin-left: 5px;
    }
    .doan_van {
      margin-top: 15px;
      font-weight: bold;
      margin-left: 4px;
    }
    .d-flex {
      display: flex;
      margin-left: 10px;
      margin-top: 5px;
      align-items: baseline;
    }
	  .disabled_answer_questions {
        color: black;
    }
    .line-height {
        line-height: 25px;
        margin-top: -6px;
    }
    .tast-right {
        padding: 0;
    }
    .ml-dh-auto.ms34.mb {
      margin-top: 10px;
    }
    .ml-dh-auto.mb {
      flex: 0 0 100%;
    }
    .ml-dh-auto {
      flex: 0 0 100%;
      margin-top: 5px;
    }
    .nmjs {
        display: inline-flex;
    }
    .nhts-he {
      display: flex;
      flex-wrap: wrap;
      margin-top: 0 !important;
      margin-left: 10px;
    }
    .nhts223 {
      margin-top: 10px;
    }
    .nhts223.flxs {
      display: flex;
    }
    .nhts223-pp-p {
      font-size: 18px;
      margin-top: 5px;
    }
    .task_page {
        width: 100%;
        min-width: 480px;
        background-color: rgb(100, 101, 112);
        background: url(../../../static/images/bg/personset_bg.jpg);
        background-size: cover;
        background-repeat: no-repeat;
        display: flex;
        position: relative;
    }

    .task_main {
        background-color: rgba(65, 65, 65, 0.5);
        width: 100%;
        height: 100%;
        padding-bottom: 50px;
        min-height: calc(100vh - 50px);
    }

    .taskPage {
        /*min-width: 1200px;*/
        width: 80%;
        margin: 0 auto;
        padding-top: 60px;
        padding-bottom: 50px;
        position: relative;
    }

    .task_answer_span {
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
        background-color: rgba(0, 0, 0, 0.3);
    }

    .taskPage_top {
        margin-top: 60px;
    }

    .taskPage_top p {
        width: calc(60% + 80px);
        /* height: 30px; */
        line-height: 30px;
        margin: 0 auto;
        color: #e8e6e6;
        font-size: 30px;
        font-family: lato, sans-serif;
        font-weight: 300;
        font-style: normal;
    }

    .taskPage_top p:last-child {
        font-size: 20px;
    }

    .taskPage_task_b {
        min-width: 600px;
        width: 60%;
        margin: 0 auto;
        padding-bottom: 40px;
        background-color: rgba(0, 0, 0, 0.3);
        border-radius: 0px 0px 20px 20px;
        box-shadow: 0 0 6px rgba(0, 0, 0, 0.3);
        min-height: 50px;
        position: relative;
    }

    .taskPage_task {
        min-width: 600px;
        width: 60%;
        margin: 0 auto;
        margin-top: 40px;
        /*padding: 0 20px;*/
        padding-bottom: 40px;
        background-color: rgba(0, 0, 0, 0.3);
        border-radius: 20px 20px 0px 0px;
        box-shadow: 0 0 6px rgba(0, 0, 0, 0.3);
    }

    .taskPage_task .task_top {
        height: 40px;
        line-height: 40px;
    }

    .task_btn {
        height: 25px;
        line-height: 25px;
        width: 60px;
        margin: 10px 0 0 20px;
        background-color: unset;
        font-size: 12px;
        color: rgb(232, 230, 230);
        font-weight: 200;
        border: 1px #fff solid;
        transition: 0.5s ease;
        border-radius: 12.5px;
    }

    .task_btn:hover {
        background-color: #fff;
        color: #000;
        transition: 0.5s ease;
    }

    .previous_task {
        position: relative;
        float: left;
        cursor: pointer;
    }

    .next_task {
        position: relative;
        float: right;
        margin-top: -40px;
        cursor: pointer;
    }

    .taskContent_page {
        width: 80%;
        height: 40px;
        position: relative;
        margin: 0 auto;
    }

    .taskContent_main {
        margin-top: 20px;
        padding: 0 100px;
        font-size: 14px;
        /* color: #e8e6e6; */
        text-align: left;
        /*height: 270px;*/
        word-wrap: break-word;
        /* word-break: break-all; */
    }

    .taskContent_main .task_content {
        line-height: 20px;
        font-size: 14px;
        /* color: #e8e6e6; */
        /* text-align: left; */
        font-family: lato, sans-serif;
        font-weight: 300;
        font-style: normal;
        text-align: justify;
    }

    .taskContent_main .task_content p {
        width: 100%;
    }

    .taskContent_main .answer_note {
        margin-bottom: 10px;
        color: #ff5252;
        font-size: 12px;
        font-family: source-han-sans-simplified-c, sans-serif;
        font-weight: 200;
        font-style: normal;
    }

    .task_answer_radio {
        /*min-width: 450px;*/
        /*width: cacl(60% - 50px);*/
        margin-top: 20px;
        /*margin-left: 20px;*/
    }

    .task_answer_radio p {
        width: calc(100% - 40px);
        line-height: 20px;
        font-size: 14px;
        color: #e8e6e6;
        /* text-align: left; */
        /*margin-left: 20px;*/
        margin-top: 15px;
        /* display: inline-flex; */
        display: -webkit-box;
        font-family: lato, sans-serif;
        font-weight: 300;
        font-style: normal;
        text-align: justify;
    }

    .task_answer_radio p label {
        display: -webkit-box;
    }

    .task_answer_radio p span {
        cursor: pointer;
    }

    .task_answer_radio input {
        height: 13px;
        margin-right: 10px;
        margin-top: 5px;
    }

    .task_answer_text {
        margin-top: 20px;
        width: calc(100% - 40px);
        padding: 2px;
        padding-left: 3px;
        padding-right: 3px;
        background-color: #585858;
        border-radius: 20px;
    }
    .task_answer_text:focus {
        border: 1px #ff5252 solid !important;
    }

    .task_answer_text textarea {
        margin-top: 2px;
        margin-right: 1px;
        width: 100%;
        max-width: 100%;
        min-width: 100%;
        height: 160px;
        line-height: 20px;
        background-color: #fff;
        border-radius: 20px;
        /* background:url("../../../static/images/manual_zh_10.png") no-repeat; */
        font-size: 14px;
        color: #0f0f0f;
        text-align: left;
        border: 0;
        outline: none;
        padding-left: 8px;
        padding-right: 8px;
        /* resize: none; */
    }
    .task_answer_text textarea:focus {
        /* border: 0 !important;
  background: #585858;
  color: #e8e6e6; */
        color: #363030;
    }

    .task_answer_text textarea::-webkit-input-placeholder {
        color: #e8e6e6;
    }

    .task_answer_text textarea::-moz-placeholder {
        /* Mozilla Firefox 19+ */
        color: #e8e6e6;
    }

    .task_answer_text textarea:-moz-placeholder {
        /* Mozilla Firefox 4 to 18 */
        color: #e8e6e6;
    }

    .task_answer_text textarea:-ms-input-placeholder {
        /* Internet Explorer 10-11 */
        color: #e8e6e6;
    }
    .submitButton_d {
        line-height: 20px;
        padding: 4px 12px 5px 12px;
        font-size: 12px;
        color: #fff;
        background-color: unset;
        border-radius: 20px;
        border: 1px #fff solid;
        font-family: source-han-sans-simplified-c, sans-serif;
        font-weight: 200;
        font-style: normal;
        transition: 0.5s ease;
        position: absolute;
        left: 40%;
        bottom: 30px;
        transform: translate(-50%, 0);
    }
    .submitButton:hover {
        color: #414141;
        background-color: #fff;
        transition: 0.5s ease;
    }
    .submitButton_c {
        line-height: 20px;
        padding: 4px 12px 5px 12px;
        font-size: 12px;
        color: #fff;
        background-color: unset;
        border-radius: 20px;
        border: 1px #fff solid;
        font-family: source-han-sans-simplified-c, sans-serif;
        font-weight: 200;
        font-style: normal;
        transition: 0.5s ease;
        position: absolute;
        left: 60%;
        bottom: 30px;
        transform: translate(-50%, 0);
    }
    .submitButton_c:hover {
        color: #414141;
        background-color: #fff;
        transition: 0.5s ease;
    }
    .submitButton {
        line-height: 20px;
        padding: 4px 12px 5px 12px;
        font-size: 12px;
        color: #fff;
        background-color: unset;
        border-radius: 20px;
        border: 1px #fff solid;
        font-family: source-han-sans-simplified-c, sans-serif;
        font-weight: 200;
        font-style: normal;
        transition: 0.5s ease;
        position: absolute;
        left: 50%;
        bottom: 30px;
        transform: translate(-50%, 0);
    }
    .submitButton:hover {
        color: #414141;
        background-color: #fff;
        transition: 0.5s ease;
    }
    .prev_btn {
        left: calc(30% - 100px);
        bottom: 30px;
    }
    .next_btn {
        left: calc(70% + 100px);
        bottom: 30px;
    }
    .task_post .el-dialog {
        background-color: #585858;
    }
    .taskPage_task_edit {
        /*width: 100%;*/
        min-height: 500px;
        position: relative;
    }
    .commit_dialog {
        background-color: #585858;
    }
    .right_span {
        float: right;
    }

    @media screen and (max-width: 1024px) {
        .taskPage {
            width: 94%;
            /*min-width: 500px;*/
            padding: 3%;
        }
        .taskPage_task_edit {
            width: 94%;
            margin: 0 3%;
            min-width: unset;
        }
        .taskPage_task_b {
            width: 94%;
            margin: 0 3%;
            min-width: unset;
        }
        .taskContent_main {
            padding: 0 50px;
        }
    }
    .testPage_time {
        width: 220px;
        height: 55px;
        line-height: 55px;
        text-align: center;
        border: 2px solid rgba(153, 153, 151, 1);
        background-color: transparent;
        border-radius: 15px;
        color: rgb(85, 76, 76);
        margin: 0 auto;
        font-size: 35px;
        font-family: myfont;
        margin-top: 20px;
    }
    .btn-tast img {
        cursor: pointer !important;
    }
    .btn-examCommit {
        text-align: center;
    }
    .btn-examCommit .tl {
        width: 30% !important;
        border-radius: 10px;
    }
    .primarylists .titles .title {
        text-transform: none !important;
    }
    .btn-custom-cancel {
        float: right;
        margin-left: 10px;
        margin-top: 2px;
    }
    .taskContent_page {
        width: 80%;
        height: 40px;
        position: relative;
        margin: 0 auto;
    }
    /* 设置滚动条的样式 */
    .taskContent_page ::-webkit-scrollbar {
        /*滚动条整体样式*/
        width: 100%;
        height: 10px;
        border-radius: 20px;
    }

    .taskContent_page ::-webkit-scrollbar-thumb {
        /*滚动条里面小方块*/
        cursor: pointer;
        border-radius: 20px;
        background-color: #646469;
    }

    .taskContent_page ::-webkit-scrollbar-track {
        /*滚动条里面轨道*/
        border-radius: 20px;
        background-color: #cfcbcb;
    }

    .taskContent_page ul {
        /* max-width: 480px; */
        list-style: none;
        overflow: auto;
        white-space: nowrap;
        text-align: center;
    }

    .taskContent_page ul li {
        width: 36px;
        height: 36px;
        background: rgba(0, 0, 0, 0.6);
        border-radius: 10px;
        margin-right: 5px;
        text-align: center;
        display: inline-block;
        margin-bottom: 6px;
        position: relative;
        cursor: pointer;
    }

    .taskContent_page ul li.activeItem {
        background: #0071c5 !important;
        color: #fff !important;
    }

    .taskContent_page ul li p {
        width: 36px;
        height: 24px;
        line-height: 35px;
        font-family: SourceHanSansCN-Normal;
        font-size: 15px;
        font-weight: bold;
        font-stretch: normal;
        letter-spacing: 0px;
        color: #181616;
        outline: none;
        user-select: none;
    }

    .taskContent_page ul li:last-child {
        margin-right: 0;
    }
	.task_result_content{
		display: inline-flex;
		/* margin-left: 18px; */
		margin-top: 15px;
	}
	.task_result_content {
        display: inline-flex;
        /* margin-left: 18px; */
        margin-top: 15px;
    }
    .task_result_content span {
        padding-left: 5px;
    }
    .task_result_content .task_result_content_rigth {
        font-weight: bold;
        color: #129b0680;
    }
    .task_result_content .task_result_content_wrong {
        font-weight: bold;
        color: #f3040480;
    }
	.task_result_answer {
        display: inline-flex;
        /* margin-left: 18px; */
        margin-top: 5px;
    }
    .task_result_answer .task_result_answer_a {
        color: rgba(10, 10, 10, 0.5);
        font-weight: bold;
        white-space: nowrap;
    }
    .task_result_answer .task_result_answer_b {
        color: #0071c5;
        font-weight: bold;
        margin-top: 2px;
    }
    .btn-tast span {
        padding-bottom: 5px;
        padding-top: 1px;
    }
    .task_result_analysis {
        display: inline-flex;
        /* margin-left: 18px; */
        margin-top: 15px;
        font-weight: bold;
    }
    .task_result_analysis_answer {
        /* margin-left: 18px; */
        font-weight: bold;
    }
    .task_result_analysis_a {
        white-space: nowrap;
        color: rgba(10, 10, 10, 0.5);
    }
	@media screen and (max-width: 480px) {
        .task_result_content {
            margin-left: 4px !important;
        }
        .task_result_answer {
            margin-left: 4px !important;
        }
        .task_result_analysis {
            margin-left: 4px !important;
        }
        .task_result_analysis_answer {
            margin-left: 4px !important;
        }
    }
	.task_right {
        background: #64cf80 !important;
    }
    .task_wrong {
        background: #fc794f !important;
    }
</style>


// WEBPACK FOOTER //
// src/views/exam/examBook.vue